import { Component, Input, OnDestroy, OnInit, ViewChild } from '@angular/core';
import { BehaviorSubject } from 'rxjs';
import { IQRBatchForm, IQRBatchForm_BrandItem, IQRBatchForm_Response, IQRBatchForm_SelectedBrand } from '../../qr-products.interface';
import { ModalComponent } from '@shared/components/modal/modal.component';
import { ModalConfig } from '@shared/components/modal/modal.interface';
import { STRING_CONSTANTS } from '@config/constants/string.constants';
import { UtilitiesService } from '@services/utilities.service';
import { QrProductsService } from '../../qr-products.service';
import { map } from 'rxjs/operators';

@Component({
  selector: 'app-modal-confirm-create',
  templateUrl: './modal-confirm-create.component.html',
  styleUrls: ['./modal-confirm-create.component.scss'],
})
export class ModalConfirmCreateComponent implements OnInit, OnDestroy {
  @Input() selectedListBrand: BehaviorSubject<IQRBatchForm_SelectedBrand>;

  @ViewChild('modalConfirmCreate') confirmDialog: ModalComponent;
  modalConfig: ModalConfig = {
    modalTitle: 'Tambah Batch',
    closeButtonLabel: 'Batal',
    dismissButtonLabel: 'Lanjutkan',
    onDismiss: () => this.dismissConfirmDialog(),
  };

  @ViewChild('modalResponseCreate') responseDialog: ModalComponent;
  modalConfigResponse: ModalConfig = {
    dismissButtonLabel: 'Oke',
    hideCloseButton: () => true,
    disableDismissButton: () => this.loadingPost.value,
    onDismiss: () => this.qrProductService.routeToListPage(),
  };

  loadingPost = new BehaviorSubject(false);
  responsePost: IQRBatchForm_Response;

  constructor(private utilitiesService: UtilitiesService, private qrProductService: QrProductsService) {}

  ngOnInit() {}

  openConfirmDialog() {
    return this.confirmDialog.open();
  }

  dismissConfirmDialog() {
    this.loadingPost.next(true);
    this.confirmDialog.close().then(() => this.postQRBatch());
    return this.responseDialog.open();
  }

  mapDataToSubmit(): IQRBatchForm {
    const { batch_name, list } = this.selectedListBrand.value;
    const list_brand: IQRBatchForm_BrandItem[] = [];

    list.map((_item) => {
      const { id, generate_qty } = _item;
      list_brand.push({
        brand_id: id,
        generate_qty: +generate_qty,
      });
    });

    return {
      batch_name,
      list_brand,
    };
  }

  postQRBatch() {
    const _payload = this.mapDataToSubmit();

    this.qrProductService
      .createQRBatch(_payload)
      .pipe(
        map((resp) => {
          if (resp && !resp.success) {
            this.loadingPost.next(false);
          }

          return resp && resp.data;
        })
      )
      .subscribe((res) => {
        if (!res) {
          return;
        }

        const { batch_name, estimate_finish_date } = res;
        this.responsePost = {
          batch_name,
          estimate_finish_date,
        };

        this.loadingPost.next(false);
      });
  }

  renderQtyString(num: number) {
    return this.utilitiesService.toThousandConvert(num);
  }

  ngOnDestroy() {}

  protected readonly STRING_CONSTANTS = STRING_CONSTANTS;
}
